<div class="card to-be-billed">
  <div class="card-header" i18n="@@UsersTransactionsSettleUpHeader">
    <h5>
      <app-svg source="icons/feather/cash-out" height="18"></app-svg>
      Einnahmen und Auszahlungen
    </h5>
  </div>

  <div class="card-body" *ngIf="isLoading">
    <div class="loading-spinner-container">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable">Loading...</span>
      </div>
    </div>
  </div>

  <div class="card-body" *ngIf="!isLoading">
    <!-- <p style="padding-bottom: 5px; display: flex; gap: 10px; align-items: flex-end; justify-content: space-between; border-bottom: 1px solid rgba(var(--white), 0.5);">
      <span>Offene Beträge aus manueller Abrechnung</span>
      <strong style="line-height: 1; font-size: 1rem; font-weight: 900;">
        {{ amountDue?.manualInvoiceItemsAmountDue | currency:'EUR' }}
      </strong>
    </p> -->

    <p style="padding-bottom: 5px; display: flex; gap: 10px; align-items: flex-end; justify-content: space-between; border-bottom: 1px solid rgba(var(--white), 0.5);">
      <span>Einnahmen aus QR-Code-Laden und automatischer Abrechnung seit der letzten Auszahlung</span>
      <strong style="line-height: 1; font-size: 1rem; font-weight: 900;">
        {{ amountDue?.revenueSinceLastPayout | currency:'EUR' }}
      </strong>
    </p>

    <p style="padding-bottom: 5px; display: flex; gap: 10px; align-items: flex-end; justify-content: space-between; border-bottom: 1px solid rgba(var(--white), 0.5);">
      <strong>Höhe der nächsten Auszahlung</strong>
      <strong style="line-height: 1; font-size: 1.5rem; font-weight: 900;">
        {{ amountDue?.amountDue | currency:'EUR' }}
      </strong>
    </p>

    <p><strong>Am 3.&nbsp;{{ scheduledPayoutDate | date:'MMMM&nbsp;YYYY' }}</strong> erfolgt automatisch die nächste Auszahlung der Einnahmen aus QR-Code-Laden und automatischer Abrechnung.</p>
    
    <div class="button-group">
      <button type="button" class="btn btn-yellow" [routerLink]="['settings']" [disabled]="isSupporter">
        <app-svg source="icons/feather/sliders" height="18"></app-svg>
        <span class="d-md-inline ps-1" i18n="@@SettingsButton">Einstellungen</span>
      </button>
      
      <button type="button" class="btn btn-yellow" [routerLink]="['payout-statements']" [disabled]="isSupporter">
        <app-svg source="icons/feather/bill" height="18"></app-svg>
        <span class="d-md-inline ps-1" i18n="@@PayoutStatements">Auszahlungsbelege</span>
      </button>
      
      <button type="button" class="btn btn-yellow" [disabled]="amountDue?.amountDue < 1 || isSupporter" 
       (click)="payout()" *ngIf="isOperator">
        <app-svg source="icons/feather/cash-out" height="18"></app-svg>
        <span class="d-md-inline ps-1" i18n="@@PayoutNow" *ngIf="amountDue?.amountDue >= 1">Jetzt auszahlen</span>
        <span class="d-md-inline ps-1" i18n="@@PayoutOnlyMoreThan1Euro" *ngIf="amountDue?.amountDue < 1">Auszahlung erst ab 1,00&thinsp;€</span>
      </button>
    </div>
  </div>
</div>
